import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, ColorPicker } from '@itds/elements/index.js';
import { Colors } from '@itds/Theme';

import { Api } from '@brokerage/utils/Api';

const ThemeOptions = ({ form_engine, loadFormEngine }) => {
  const [color, setColor] = useState(form_engine.theme_options.color || Colors.PRIMARY.hex);

  const handleColorChange = color => {
    setColor(color.hex);
  };

  const handleSave = () => {
    Api.updateFormEngineThemeOptions(form_engine.theme_options.id, { color }).then(() => {
      loadFormEngine();
    });
  };

  return (
    <div>
      <ColorPicker color={{ hex: color }} label='Theme Color' onChange={handleColorChange} />

      <div style={{ marginTop: 30 }}>
        <Button inline={true} onClick={handleSave}>
          Save
        </Button>
      </div>
    </div>
  );
};

ThemeOptions.propTypes = {
  form_engine: PropTypes.object,
  loadFormEngine: PropTypes.func
};

export default ThemeOptions;
